import React from "react";
import "./PropuestasMatrimonioPage.css";
import { Trans, useTranslation } from 'react-i18next'; 
import ContactButton from "../../../../../components/atoms/ContactButton/ContactButton"; 


import propuestasHero from "../../../../../assets/PropuestasMatrimonio-Hero.png";

const PropuestasMatrimonioPage: React.FC = () => {
 
  const { t } = useTranslation();

  return (
    <div className="propuestas-container">
      
      
      <header
        className="propuestas-hero fade-in"
        style={{ backgroundImage: `url(${propuestasHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="marriageProposalsPage:heroTitle" />
        </h1>
      </header>

      
      <section className="info-section fade-up">
        <h2 className="info-title">
          <Trans i18nKey="marriageProposalsPage:infoTitle" />
        </h2>
        <p className="info-text">
          <Trans 
            i18nKey="marriageProposalsPage:infoText"
            components={{ strong: <strong /> }}
          />
        </p>
      </section>

      
      <section className="cta-section fade-up">
        <p>
          <Trans i18nKey="marriageProposalsPage:ctaText" />
        </p>
        <ContactButton />
      </section>

    </div>
  );
};

export default PropuestasMatrimonioPage;